// extracted by mini-css-extract-plugin
export default {"title":"order-card-page_title__+2nYi"};